import React from 'react';

export default function LoadingScreen() {
  return (
    <div style={loaderStyle}>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      <div style={spinnerStyle}></div>
      <span style={textStyle}>tribe</span>
    </div>
  );
}

const loaderStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: '#fff',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
};

const spinnerStyle = {
  width: '48px',
  height: '48px',
  border: '4px solid #f3f3f3',
  borderTop: '4px solid #007AFF',
  borderRadius: '50%',
  animation: 'spin 1s linear infinite',
};

const textStyle = {
  marginTop: '16px',
  fontSize: '18px',
  fontWeight: 'bold',
  color: '#333',
  textTransform: 'lowercase',
};
